import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CheckInServicePendingChecklist } from "models";

export const useAddServicePendingChecklistMutation = () =>
  useTypedMutation<CheckInServicePendingChecklist, void>({
    mutationFn: async payload => (await ApiInstance.post("/service_pending_checklists/create", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const servicePendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.servicePendingChecklists);
      if (!servicePendingChecklists) return;

      const servicePendingChecklistIdx = servicePendingChecklists.findIndex(
        p => p.checklist_id === payload.checklist_id && p.checkin_service_id === payload.checkin_service_id
      );
      if (servicePendingChecklistIdx >= 0) return;

      typedQueryClient.setQueryData(PendingChecklistsQueryKeys.servicePendingChecklists, [...servicePendingChecklists, payload]);
    }
  });
